"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var React = __importStar(require("react"));
function UndrawVisualData(p) {
  var primaryColor = p.primaryColor,
    height = p.height,
    style = p.style,
    props = __rest(p, ["primaryColor", "height", "style"]);
  var styleProps = __assign({
    width: '100%',
    height: height
  }, style);
  return React.createElement("svg", __assign({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: "1em",
    height: "1em",
    viewBox: "0 0 821.168 687.802",
    style: styleProps
  }, props), React.createElement("path", {
    fill: "#9e616a",
    d: "M755.994 674.556l-12.26-.001-5.832-47.287h18.094l-.002 47.288z"
  }), React.createElement("path", {
    d: "M759.12 686.44l-39.53-.001v-.5a15.387 15.387 0 0115.386-15.387h.001l24.144.001z",
    fill: "#2f2e41"
  }), React.createElement("path", {
    fill: "#9e616a",
    d: "M708.994 674.556l-12.26-.001-5.832-47.287h18.094l-.002 47.288z"
  }), React.createElement("path", {
    d: "M712.12 686.44l-39.53-.001v-.5a15.387 15.387 0 0115.386-15.387h.001l24.144.001z",
    fill: "#2f2e41"
  }), React.createElement("path", {
    "data-name": "Path 1495",
    d: "M179.332 684.611v-379.81a8.82 8.82 0 018.82-8.82h39.36a8.82 8.82 0 018.82 8.82v380.8z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    "data-name": "Path 1496",
    d: "M309.332 685.801v-302a8.82 8.82 0 018.82-8.82h39.36a8.82 8.82 0 018.82 8.82v301.35z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M78.331 327a3 3 0 01-2.233-5.003l131.606-146.79 129.518 72.729L467.511 23.438l132.728 109.245a3 3 0 11-3.813 4.633L469.153 32.561l-129.71 223.503-130.483-73.27L80.566 326.001a2.991 2.991 0 01-2.235.998z",
    fill: "#3f3d56"
  }), React.createElement("circle", {
    "data-name": "Ellipse 300",
    cx: 77.832,
    cy: 324,
    r: 28,
    fill: primaryColor
  }), React.createElement("circle", {
    "data-name": "Ellipse 301",
    cx: 207.832,
    cy: 179,
    r: 28,
    fill: "#ccc"
  }), React.createElement("circle", {
    "data-name": "Ellipse 302",
    cx: 337.832,
    cy: 252,
    r: 28,
    fill: "#e6e6e6"
  }), React.createElement("circle", {
    "data-name": "Ellipse 303",
    cx: 467.832,
    cy: 28,
    r: 28,
    fill: primaryColor
  }), React.createElement("circle", {
    "data-name": "Ellipse 304",
    cx: 717.832,
    cy: 236.535,
    r: 28,
    fill: primaryColor
  }), React.createElement("path", {
    "data-name": "Path 1507",
    d: "M707.932 454.656c10.48 1.262 37.279-8.298 38.731 6.246 13.794 40.605 13.385 196.257 13.385 196.257l-21 1s-16.781-123.675-24.716-150.133c-3.982 32.159-3.284 155.133-3.284 155.133l-19 1s-17.043-104.718-17.14-135.453c-2.072-22.514 3.008-55.876.834-77.64a83.218 83.218 0 0032.19 3.59z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    "data-name": "Path 1513",
    d: "M569.332 684.455V246.701c0-5.614 3.949-10.166 8.82-10.166h39.36c4.871 0 8.82 4.551 8.82 10.166v438.9z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    "data-name": "Path 1508",
    d: "M672.282 336.856a130.657 130.657 0 00-15.31-24.17 38.322 38.322 0 01-3.4-4.64c-2.15-3.73-2.79-8.11-4.15-12.19-3.8-11.44-13.28-20.63-15.59-32.46-.84-4.3-7.936 8.198-6.07 13.53 3.33 9.65 3.76 19.87 8 29.19s9.22 18.26 12.88 27.79c2.08 5.41 3.74 11 6.79 16s7.81 9.19 13.56 9.94a33.45 33.45 0 011.63-10.68c1.25-3.94 3.47-8.58 1.66-12.31z",
    fill: "#9e616a"
  }), React.createElement("path", {
    "data-name": "Path 1509",
    d: "M735.192 343.336a55.259 55.259 0 013.25-20.78c.92-2.55 2-5.14 1.91-7.85-.13-2.52-1.33-4.83-2.42-7.11-3.76-7.85-6.4-16.17-9-24.47l-5-15.65c-1.63-1.195 7.89-1.61 9.92 1.2 6.64 9.22 11.67 19.81 16.93 29.88a50.577 50.577 0 013.42 7.49 41.186 41.186 0 011.8 12.94c0 8.19-1.08 16.35-2.2 24.47-.71 5.09-1.64 10.63-5.49 14-4-5.12-8.02-10.12-13.12-14.12z",
    fill: "#9e616a"
  }), React.createElement("circle", {
    "data-name": "Ellipse 307",
    cx: 708.752,
    cy: 314.484,
    r: 20.75,
    fill: "#9e616a"
  }), React.createElement("path", {
    "data-name": "Path 1512",
    d: "M691.884 293.782a3.602 3.602 0 01.76-3.723c.518-.409 1.206-.561 1.761-.95a7.602 7.602 0 001.9-2.404 10.315 10.315 0 0112.909-3.276c3.429 1.794 5.5 5.388 8.549 7.808 1.548 1.254 3.344 2.184 4.902 3.438a20.146 20.146 0 016.354 10.278 58.31 58.31 0 011.762 12.125 10.905 10.905 0 01-.142 3.686 10.317 10.317 0 01-1.396 2.85c-3.135 4.749-7.266 9.062-12.444 11.513s-11.475 2.85-16.58.285a2.85 2.85 0 01-1.273-1.017 3.658 3.658 0 01-.199-2.194 15.018 15.018 0 00-1.653-8.406c-.95-1.9-2.375-3.534-3.135-5.5a19.16 19.16 0 01-.893-6.82c-.09-5.98.316-11.936-1.182-17.693z",
    fill: "#2d293d"
  }), React.createElement("path", {
    "data-name": "Path 1514",
    d: "M49.331 685.05V473.709c0-2.71 3.949-4.908 8.82-4.908h39.36c4.871 0 8.82 2.2 8.82 4.908v211.892z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    "data-name": "Path 944",
    d: "M820.169 687.802H1a1 1 0 110-2h819.168a1 1 0 010 2z",
    fill: "#e6e6e6"
  }), React.createElement("path", {
    "data-name": "Path 1515",
    d: "M439.331 684.306v-496.77c0-6.371 3.949-11.536 8.82-11.536h39.36c4.871 0 8.82 5.165 8.82 11.536v498.065z",
    fill: primaryColor
  }), React.createElement("circle", {
    cx: 627.182,
    cy: 265.366,
    r: 9,
    fill: "#a0616a"
  }), React.createElement("circle", {
    cx: 727.182,
    cy: 261.366,
    r: 9,
    fill: "#a0616a"
  }), React.createElement("path", {
    d: "M749.052 372.776c.878-.804 8.038-42.674 7.996-43.617-.11-5.159-15.85-11.05-19-9-2.972 1.934-8.147 24.124-11.477 28.165l-3.523-6.165h-28l-1.697 3.151c-3.674-2.213-6.98-4.254-8.158-4.929a5.3 5.3 0 00-1.311-.645 20.31 20.31 0 01-8-3.76c-2.3-1.77-12.974-20.307-15.834-19.817-3.23.54-14.125 9.96-14 19 1.371-.03 19.214 35.647 19.464 36.977 1.37 5.62 5.894 87.58 7.354 91.4 6.726-.65 1.416-1.81 7.926 0 7.01 1.95 14.41-.16 21.64-.94a83.114 83.114 0 019.06-.4c11 .05 26.7.66 37.35 3.39.06-6.98-6.07-22.08-8.34-28.67a19.248 19.248 0 01.03-5.94c.29-2.41 6.146-55.535 8.52-58.2z",
    fill: "#e6e6e6"
  }));
}
exports.default = UndrawVisualData;